import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((themes) => ({
  container: {
    alignSelf: "center",
    marginTop: "50px",
    justifySelf: "center",
  },
}));
